import React from 'react';
import SVGLoader from './SVGLoader';

const StreamlineIcon = props => {
  return (
    <SVGLoader
      {...props}
      width={13}
      height={25}
      viewboxHeight={11}
      viewboxWidth={10}
    >
      <path
        d="M5.372,3.166a.516.516,0,0,0-.744,0l-2.25,2.5A.5.5,0,0,0,2.75,6.5h1.5V9.25a.75.75,0,0,0,1.5,0V6.5h1.5a.5.5,0,0,0,.372-.834Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
      <path
        d="M7.5,0h-5a.75.75,0,0,0,0,1.5h5A.75.75,0,0,0,7.5,0Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0"
      ></path>
    </SVGLoader>
  );
};

export default StreamlineIcon;
